module.exports = __webpack_public_path__ + "img/mt5-icon8.44d97a9.png";